module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "div_autre"
  }, [_c('div', {
    staticClass: "pre",
    attrs: {
      "id": "pre-001"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_XIII"
    }
  }), _c('h1', {
    staticClass: "pre_tit"
  }, [_c('a', {
    attrs: {
      "id": "page_XIII"
    }
  }, [_c('span')]), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "rXIII"
    }
  }, [_vm._v("ACKNOWLEDGMENTS")])]), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "rXIII"
    }
  }, [_vm._v("The apostle Paul wrote, “What do you have that you did not receive?” (1 Cor 4:7). And again: “For whatever was written in former days was written for our instruction, so that by steadfastness and by the encouragement of the Scriptures we might have hope” (Rom 15:4). We owe a debt of thanks to the insights of the host of Reformation commentators whose works have been included in this volume. As we are only partly responsible for this book, we wish to thank many people, beginning with the general editors of the Reformation Commentary on Scripture project, Timothy George and Scott M. Manetsch, for their confidence in us.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "rXIII"
    }
  }, [_vm._v("We owe special thanks to our project editor, David McNutt, and the assistant project editors, Todd Hains and Andre Gazal, whose attention and determination have helped to shape this volume. Since this has been a long project, we would also like to thank Mike Gibson and Brannon Ellis, who served as project editors along the way.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "rXIII"
    }
  }, [_vm._v("In addition, we would like to thank other editorial staff and assistants on this project, including David Hooper and Ethan McCarthy, as well as James Kellerman and Caroline Kelly, who helped us with translation.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "rXIII"
    }
  }, [_vm._v("We thank God for the patience and support of our spouses Nora and René, who allowed us to bring all our books and often camp in each other’s homes as we traveled from Oakland to Philadelphia to work on the volume together.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "rXIII"
    }
  }, [_vm._v("Finally, we wish to dedicate this book to our father, the Rev. Rudolf E. M. Krey, who had the vision and determination to teach us Greek, Hebrew and German while we were young and teachable. He insisted that we learn Latin and other foreign languages in school and with our mother, Gertrude E. Krey, he took his responsibilities to teach us the Scriptures and the catechism faithfully.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "rXIII"
    }
  }, [_vm._v("“May the God of steadfastness and encouragement grant you to live in harmony with one another, in accordance with Christ Jesus, so that together you may with one voice glorify the God and Father of our Lord Jesus Christ” (Rom 15:5-6).")])])]), _c('p', {
    staticClass: "sign"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "rXIII"
    }
  }, [_c('i', [_vm._v("Philip D. W. Krey")]), _c('br'), _c('i', [_vm._v("Peter D. S. Krey")]), _c('br'), _vm._v("The Festival of Pentecost 2016")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30d0e461","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pre2.vue
// module id = 69
// module chunks = 0